import { Button, Form, Input } from 'antd'
import { Popconfirm } from 'antd-v5'
import React, { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { FormItem } from 'react-hook-form-antd'
import { zodResolver } from '@hookform/resolvers/zod'
import z from 'zod'
import { useObserver } from 'lib/hooks/observer'

// 入力フォームの正規表現
const passwordRegex = {
  lowerCaseAndUpperCaseAndNumber: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/, // 小文字・大文字・数字を含める
  specialCharacter: /^(?=.*[!@#$%^&*])/, // 特殊文字を含める（!@#$%^&* など）
  characterCount: /^.{8,}$/, // ８文字以上
  consecutiveCharacters: /^(?!.*(\w)\1).*$/, //同じ文字は連続して使えない
}

const schema = z.object({
  username: z.string().min(1, { message: 'ユーザーネームは必須です。' }),
  // .max(15, { message: 'ユーザーネームは１５文字以内です。' }),
  email: z
    .string()
    .email({ message: 'メール形式が正しくありません' })
    .min(1, { message: 'メールアドレスは必須です。' }),
  password: z
    .string()
    .min(1, { message: 'パスワードは必須です。' })
    // .refine((value) => passwordRegex.lowerCaseAndUpperCaseAndNumber.test(value), {
    //   message: 'パスワードには、小文字・大文字・数字を含めてください。',
    // })
    // .refine((value) => passwordRegex.specialCharacter.test(value), {
    //   message: 'パスワードには、特殊文字(!@$%&^*)を含めてください。',
    // })
    .refine((value) => passwordRegex.characterCount.test(value), {
      message: 'パスワードは8文字以上にしてください。',
    }),
  // .refine((value) => passwordRegex.consecutiveCharacters.test(value), {
  //   message: '同じ文字を連続して使うことはできません。',
  // }),
})
export type Schema = z.infer<typeof schema>

interface ObserverFormProps {
  formType: 'create' | 'update'
  popTitle: string
  popDescription: string
  userInfo?: { id: string; username: string; email: string; password: string }
}

const ObserverForm: FC<ObserverFormProps> = ({
  formType,
  popTitle,
  popDescription,
  userInfo,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm<Schema>({
    defaultValues: {
      username: userInfo?.username,
      email: userInfo?.email,
      password: userInfo?.password,
    },
    resolver: zodResolver(schema),
  })

  const { observerAdd, observerUpdate } = useObserver()

  // userInfoに変更があったら初期値を変更
  useEffect(() => {
    if (formType === 'update') {
      reset({
        username: userInfo?.username,
        email: userInfo?.email,
        password: userInfo?.password,
      })
    }
  }, [userInfo, reset, formType])

  return (
    <>
      <Form
        name="basic"
        layout="vertical"
        labelCol={{ span: 8 }}
        style={{ maxWidth: 600 }}
        autoSave="off"
      >
        <FormItem
          control={control}
          name="username"
          label="Username"
          required={true}
        >
          <Input placeholder="ex) 佐賀商店" defaultValue={userInfo?.username} />
        </FormItem>

        <FormItem control={control} name="email" label="Email" required={true}>
          <Input
            placeholder="ex) saga@sample.com"
            defaultValue={userInfo?.email}
          />
        </FormItem>

        <FormItem
          control={control}
          name="password"
          label="Password"
          required={true}
        >
          <Input.Password
            placeholder="ex) Saga@1234"
            disabled={formType === 'update'}
            defaultValue={userInfo?.password}
          />
        </FormItem>

        {/* 追加ボタン */}
        <Form.Item>
          <div className="flex gap-4">
            <Popconfirm
              title={popTitle}
              description={popDescription}
              okText="はい"
              cancelText="いいえ"
              onConfirm={handleSubmit((data) => {
                if (formType === 'create') {
                  observerAdd(data)
                } else if (formType === 'update') {
                  observerUpdate(data, userInfo.id)
                }
              })}
            >
              <Button type="primary" htmlType="submit" disabled={!isValid}>
                {formType === 'create' ? '追加' : '更新'}
              </Button>
            </Popconfirm>
            <Button onClick={() => reset()}>リセット</Button>
          </div>
        </Form.Item>
      </Form>
    </>
  )
}

export default ObserverForm
